import { registerRootComponent } from 'expo'
import 'expo-dev-client'
import { LogBox, Text, TextInput } from 'react-native'

import { App } from './App.tsx'

Text.defaultProps = Text.defaultProps || {}
Text.defaultProps.allowFontScaling = false
TextInput.defaultProps = TextInput.defaultProps || {}
TextInput.defaultProps.allowFontScaling = false

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App)

LogBox.ignoreAllLogs()
LogBox.ignoreLogs([
  "Modal with 'pageSheet' presentation style and 'transparent' value is not supported.",
  'Warning: Each child in a list should have a unique "key" prop.',
])
